import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import demo from "./modules/demo";
import getters from "./getters";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";
export default new Vuex.Store({
  modules: {
    demo
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
  strict: debug,
  // store持久化插件, 文档见 https://github.com/robinvdvleuten/vuex-persistedstate
  plugins: [createPersistedState()]
});
